import script from "./CountryInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CountryInput.vue?vue&type=script&setup=true&lang=js"

import "./CountryInput.vue?vue&type=style&index=0&id=212dcc10&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-212dcc10"]])

export default __exports__